import { Component, EventEmitter, Input, Output } from '@angular/core';

import { Observable } from 'rxjs';

import { ApiTopic, SubjectCategoriesClient } from 'content-manager/src/app/core/open-api/content-manager-api-client';

@Component({
    selector: 'cm-topic-picker',
    templateUrl: './topic-picker.component.html',
    standalone: false
})
export class TopicPickerComponent {

    @Input() public selected: string[] = [];

    @Input() public disabled = false;

    @Input() public hintText: string | null = null;

    @Output() public readonly selectedChange = new EventEmitter<string[]>();

    public readonly topics$: Observable<ApiTopic[]>;

    constructor(subjectCategoriesClient: SubjectCategoriesClient) {
        this.topics$ = subjectCategoriesClient.getTopics();
    }

    public onSelectedChange(value: string[]): void {
        this.selected = value;
        this.selectedChange.emit(value);
    }
}
